module.exports = __webpack_public_path__ + "img/6.16a172a7.jpg";